import { AsyncModule } from 'vuex-async-mutations';

import { InstallationState } from './index';

import { actionsAsync, actions } from './installation.actions';
import { mutationsAsync, mutations } from './installation.mutations';
import getters from './installation.getters';

export default {
  async: true,
  getters,
  mutationsAsync,
  mutations,
  actionsAsync,
  actions,
} as AsyncModule<InstallationState, any>;
